export default __webpack_public_path__ + "static/media/earl blumenauer.911c397c.jpg";